/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import React from "react";
import ErrorTextProps from "./ErrorTextProps";
import "./ErrorText.scss";

export default function ErrorText(props: ErrorTextProps) {
    return (
        <>
            {props.errors.map((error, index) => (
                <span key={index} className="lan-errortext__span">{error}</span>
            ))
            }
        </>
    );
}
